import clsx from "clsx";
import logo from "../images/logo.png";
import axios from "axios";
import Adresspopup from "./Adresspopup";
import { Link } from "react-router-dom";
import { useNavigate } from "react-router-dom";
import React, { useEffect, useRef, useState } from "react";
import editIcon from "../images/editicon.svg";
import { toast } from "react-toastify";
import { Helmet } from "react-helmet";
import { api_url } from "../config/config";

const plusPattern = `url("data:image/svg+xml,%3Csvg width='40' height='40' viewBox='0 0 40 40' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Crect x='17' y='10' width='6' height='20' rx='2' fill='white'/%3E%3Crect x='10' y='17' width='20' height='6' rx='2' fill='white'/%3E%3C/svg%3E")`;

const indianStates = [
  "Andhra Pradesh",
  "Arunachal Pradesh",
  "Assam",
  "Bihar",
  "Chhattisgarh",
  "Goa",
  "Gujarat",
  "Haryana",
  "Himachal Pradesh",
  "Jharkhand",
  "Karnataka",
  "Kerala",
  "Madhya Pradesh",
  "Maharashtra",
  "Manipur",
  "Meghalaya",
  "Mizoram",
  "Nagaland",
  "Odisha",
  "Punjab",
  "Rajasthan",
  "Sikkim",
  "Tamil Nadu",
  "Telangana",
  "Tripura",
  "Uttar Pradesh",
  "Uttarakhand",
  "West Bengal",
  "Andaman and Nicobar Islands",
  "Chandigarh",
  "Dadra and Nagar Haveli and Daman and Diu",
  "Delhi",
  "Jammu and Kashmir",
  "Ladakh",
  "Lakshadweep",
  "Puducherry",
];

const InputField = ({ label, required, error, children }) => (
  <div className="flex flex-col gap-1.5">
    <label className="text-[12px] font-semibold text-[#374747] flex items-center gap-1">
      {label} {required && <span className="text-[#ff601e]">*</span>}
    </label>
    {children}
    {error && (
      <p className="text-[11px] text-red-500 flex items-center gap-1">
        <svg
          width="10"
          height="10"
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          strokeWidth="2.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        >
          <circle cx="12" cy="12" r="10" />
          <line x1="12" y1="8" x2="12" y2="12" />
          <line x1="12" y1="16" x2="12.01" y2="16" />
        </svg>
        {error}
      </p>
    )}
  </div>
);

const inputCls = (hasError) =>
  `w-full h-11 px-4 bg-white border-[1.5px] rounded-xl font-poppins text-[13px] text-[#1a2625] placeholder-[#8faba9] outline-none transition-all duration-200 ${
    hasError
      ? "border-red-400 focus:border-red-400 focus:shadow-[0_0_0_3px_rgba(239,68,68,0.12)]"
      : "border-[#e2eaea] focus:border-[#1e4a46] focus:shadow-[0_0_0_3px_rgba(95,189,179,0.15)]"
  }`;

const ProfilePage = () => {
  const profileRef = useRef(null);
  const [userErrors, setUserErrors] = useState({});
  const [errors, setErrors] = useState({});

  const [selectedAddress, setSelectedAddress] = useState({
    deliver_to: "",
    address_title: "",
    address_line_1: "",
    address_line_2: "",
    pincode: "",
    city: "",
    state: "",
    mobile_number: "",
  });
  const [isEditPopupOpen, setIsEditPopupOpen] = useState(false);
  const [mobileNumber, setMobileNumber] = useState();
  const [addresses, setAddresses] = useState([]);
  const [isPopupOpen, setPopupOpen] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");
  const [isEditable] = useState(true);
  const [userData, setUserData] = useState({
    name: "",
    email: "",
    pincode: "",
    gst_number: "",
  });
  const [userId, setUserId] = useState("");
  const token = localStorage.getItem("authToken");
  const [activeTab, setActiveTab] = useState("profile");

  const nameRegex = /^[A-Za-z\s]+$/;
  const cityRegex = /^[A-Za-z\s]+$/;
  const addressLineRegex = /^[A-Za-z0-9\s,./\-#]+$/;
  const mobileRegex = /^\d{10}$/;
  const pincodeRegex = /^\d{6}$/;

  const titleValue = (selectedAddress.address_title || "").trim();
  const cityValue = (selectedAddress.city || "").trim();
  const addr1Value = (selectedAddress.address_line_1 || "").trim();
  const addr2Value = (selectedAddress.address_line_2 || "").trim();
  const pincodeValue = selectedAddress.pincode || "";
  const mobileValue = selectedAddress.mobile_number || "";

  const isNameValid = nameRegex.test(titleValue);
  const isCityValid = cityRegex.test(cityValue);
  const isAddress1Valid = addressLineRegex.test(addr1Value);
  const isAddress2Valid =
    addr2Value === "" || addressLineRegex.test(addr2Value);
  const isPincodeValid = pincodeRegex.test(pincodeValue);
  const isMobileValid = mobileRegex.test(mobileValue);
  const isEditFormValid =
    isNameValid &&
    isAddress1Valid &&
    isAddress2Valid &&
    isCityValid &&
    isPincodeValid &&
    isMobileValid &&
    (selectedAddress.state || "") !== "";

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const fetchUserData = async () => {
    try {
      const response = await axios.get(`${api_url}/user`, {
        headers: { Authorization: `Bearer ${token}` },
      });
      if (response.data.data) {
        const d = response.data.data;
        setUserData({
          name: d.name || "",
          email: d.email || "",
          pincode: d.pincode || "",
          user_id: d.user_id,
          mobile_number: d.mobile_number || "",
          gst_number: d.gst_number || "",
        });
        setUserId(d.user_id);
        setMobileNumber(d.mobile_number || "");
      }
    } catch (e) {
      console.error("Error fetching user data:", e);
    }
  };
  useEffect(() => {
    fetchUserData();
  }, []);

  const fetchAddresses = async () => {
    try {
      const response = await axios.get(`${api_url}/address/users`, {
        headers: { Authorization: `Bearer ${token}` },
      });
      setAddresses(response.data.data);
    } catch (e) {
      console.error("Error fetching addresses:", e);
    }
  };
  useEffect(() => {
    fetchAddresses();
  }, []);

  const validate = () => {
    let newErrors = {};
    if (!userData.name.trim()) newErrors.name = "Name is required.";
    if (userData.email && !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(userData.email))
      newErrors.email = "Enter a valid email.";
    if (!userData.pincode) newErrors.pincode = "Pincode is required.";
    else if (userData.pincode.length !== 6)
      newErrors.pincode = "Pincode must be exactly 6 digits.";
    setUserErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleSaves = async (e) => {
    e.preventDefault();
    if (!validate()) return;
    try {
      await axios.patch(
        `${api_url}/user`,
        {
          name: userData.name,
          pincode: userData.pincode,
          email: userData.email,
          gst_number: userData.gst_number,
        },
        { headers: { Authorization: `Bearer ${token}` } },
      );
      fetchUserData();
      toast.success("Profile saved successfully!");
    } catch (e) {
      toast.error("Failed to save profile.");
    }
  };

  const handleEditClick = (address) => {
    setSelectedAddress({
      ...address,
      is_default: address.is_default === true || address.is_default === "true",
    });
    setTimeout(() => setIsEditPopupOpen(true), 50);
  };
  const handleClosePopup = () => setIsEditPopupOpen(false);

  const handleChange = (e) => {
    const { name, value } = e.target;
    if (name === "pincode") {
      if (/^\d{0,6}$/.test(value))
        setSelectedAddress((p) => ({ ...p, [name]: value }));
      return;
    }
    if (name === "mobile_number") {
      setSelectedAddress((p) => ({
        ...p,
        [name]: value.replace(/\D/g, "").slice(0, 10),
      }));
      return;
    }
    if (name === "address_title") {
      setSelectedAddress((p) => ({
        ...p,
        [name]: value.replace(/[^A-Za-z\s]/g, ""),
      }));
      return;
    }
    if (name === "address_line_1" || name === "address_line_2") {
      setSelectedAddress((p) => ({
        ...p,
        [name]: value.replace(/[^A-Za-z0-9\s,./\-#]/g, ""),
      }));
      return;
    }
    if (name === "city") {
      setSelectedAddress((p) => ({
        ...p,
        [name]: value.replace(/[^A-Za-z\s]/g, ""),
      }));
      return;
    }
    setSelectedAddress((p) => ({ ...p, [name]: value }));
  };

  const validateForm = () => {
    let newErrors = {};
    if (!isAddress1Valid)
      newErrors.address_line_1 = "Address Line 1 contains invalid characters.";
    if (!isPincodeValid)
      newErrors.pincode = "Pincode must be exactly 6 digits.";
    if (!isMobileValid)
      newErrors.mobile_number = "Mobile number must be exactly 10 digits.";
    if (!isAddress2Valid)
      newErrors.address_line_2 = "Address Line 2 contains invalid characters.";
    setErrors(newErrors);
    return (
      Object.keys(newErrors).length === 0 &&
      isNameValid &&
      isCityValid &&
      (selectedAddress.state || "") !== ""
    );
  };

  const updateAddress = async (addressId) => {
    if (!addressId) return;
    try {
      const response = await axios.patch(
        `${api_url}/address/${addressId}`,
        {
          address_line_1: selectedAddress.address_line_1,
          address_line_2: selectedAddress.address_line_2,
          address_title: selectedAddress.address_title,
          pincode: parseInt(selectedAddress.pincode, 10),
          city: selectedAddress.city,
          state: selectedAddress.state,
          mobile_number: selectedAddress.mobile_number,
          is_default: selectedAddress.is_default,
        },
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
        },
      );
      if (response.data.status === "success") {
        setAddresses((prev) =>
          prev.map((addr) =>
            addr.address_id === selectedAddress.address_id
              ? {
                  ...selectedAddress,
                  mobile_number: selectedAddress.mobile_number,
                }
              : { ...addr, is_default: false },
          ),
        );
        setIsEditPopupOpen(false);
        toast.success("Address updated successfully!");
      }
    } catch (e) {
      toast.error(e?.response?.data?.message || "Failed to update address.");
    }
  };

  const handleDeleteAddress = async (addressId) => {
    try {
      const response = await fetch(`${api_url}/address/${addressId}`, {
        method: "DELETE",
        headers: { Authorization: `Bearer ${token}` },
      });
      if (response.ok) {
        setAddresses((prev) => prev.filter((a) => a.address_id !== addressId));
        toast.success("Address deleted successfully");
      }
    } catch (e) {
      console.error("Error deleting address:", e);
    }
  };

  const handleSave = () => {
    if (validateForm()) updateAddress(selectedAddress.address_id);
  };

  const tabs = [
    {
      id: "profile",
      label: "My Profile",
      icon: (
        <svg
          width="15"
          height="15"
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          strokeWidth="2.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        >
          <path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2" />
          <circle cx="12" cy="7" r="4" />
        </svg>
      ),
    },
    {
      id: "addresses",
      label: "Addresses",
      icon: (
        <svg
          width="15"
          height="15"
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          strokeWidth="2.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        >
          <path d="M21 10c0 7-9 13-9 13s-9-6-9-13a9 9 0 0 1 18 0z" />
          <circle cx="12" cy="10" r="3" />
        </svg>
      ),
    },
  ];

  return (
    <div className="min-h-screen bg-[#f8fafa] font-poppins">
      <Helmet>
        <title>User Profile | MediSYS Pharmacy</title>
        <meta
          name="description"
          content="Manage your MediSYS Pharmacy profile, addresses and preferences."
        />
        <meta name="robots" content="index, follow" />
      </Helmet>

      {/* ── Hero strip ── */}
      <div className="relative bg-[#162c2a] overflow-hidden px-5 sm:px-8 lg:px-14 pt-8 pb-12">
        <div
          className="absolute inset-0 opacity-[0.04] pointer-events-none"
          style={{
            backgroundImage: plusPattern,
            backgroundRepeat: "repeat",
            backgroundSize: "40px 40px",
          }}
        />
        <div className="absolute -top-10 right-0 w-72 h-72 rounded-full bg-[#5fbdb3]/10 blur-3xl pointer-events-none" />
        <div className="relative flex items-center gap-5">
          {/* Avatar */}
          <div className="w-16 h-16 rounded-2xl bg-gradient-to-br from-[#5fbdb3] to-[#1e4a46] flex items-center justify-center shadow-[0_4px_20px_rgba(95,189,179,0.3)] flex-shrink-0">
            <svg
              width="28"
              height="28"
              viewBox="0 0 24 24"
              fill="none"
              stroke="white"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
            >
              <path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2" />
              <circle cx="12" cy="7" r="4" />
            </svg>
          </div>
          <div>
            <p className="text-[11px] font-semibold uppercase tracking-widest text-[#5fbdb3] mb-1">
              Account
            </p>
            <h1 className="font-bold text-[22px] sm:text-[28px] text-white leading-tight">
              {userData.name || "My Profile"}
            </h1>
            {mobileNumber && (
              <p className="text-[13px] text-white/50 mt-0.5">
                +91 {mobileNumber}
              </p>
            )}
          </div>
        </div>

        {/* Tab nav */}
        <div className="relative flex items-center gap-2 mt-8">
          {tabs.map((tab) => (
            <button
              key={tab.id}
              onClick={() => setActiveTab(tab.id)}
              className={`flex items-center gap-2 px-4 h-9 rounded-xl text-[12px] font-semibold transition-all duration-200 ${
                activeTab === tab.id
                  ? "bg-white text-[#1e4a46] shadow-[0_2px_8px_rgba(0,0,0,0.15)]"
                  : "bg-white/[0.08] text-white/60 hover:bg-white/[0.14] hover:text-white"
              }`}
            >
              {tab.icon}
              {tab.label}
            </button>
          ))}
        </div>
      </div>

      {/* ── Content ── */}
      <div className="px-5 sm:px-8 lg:px-14 py-8 -mt-4">
        {/* ── PROFILE TAB ── */}
        {activeTab === "profile" && (
          <div className="max-w-full">
            <div className="bg-white rounded-2xl border border-[#e2eaea] shadow-[0_2px_16px_rgba(22,44,42,0.08)] overflow-hidden">
              {/* Card top accent */}
              <div className="h-[3px] bg-gradient-to-r from-[#162c2a] via-[#5fbdb3] to-[#ff601e]" />
              <div className="p-6 sm:p-8">
                <h2 className="font-bold text-[17px] text-[#1e4a46] mb-6">
                  Personal Information
                </h2>
                <form onSubmit={handleSaves} className="flex flex-col gap-5">
                  <InputField
                    label="Full Name"
                    required
                    error={userErrors.name}
                  >
                    <input
                      type="text"
                      placeholder="Enter your name"
                      value={userData.name}
                      onChange={(e) => {
                        const v = e.target.value;
                        if (v.trim() === "") {
                          setUserData({ ...userData, name: v });
                          setUserErrors({
                            ...userErrors,
                            name: "Name is required.",
                          });
                        } else if (/^[A-Za-z\s]*$/.test(v)) {
                          setUserData({ ...userData, name: v });
                          setUserErrors({ ...userErrors, name: "" });
                        } else
                          setUserErrors({
                            ...userErrors,
                            name: "Only alphabets are allowed.",
                          });
                      }}
                      className={inputCls(!!userErrors.name)}
                      disabled={!isEditable}
                    />
                  </InputField>

                  <InputField label="Email Address" error={userErrors.email}>
                    <input
                      type="email"
                      placeholder="Enter your email"
                      value={userData.email}
                      onChange={(e) => {
                        const v = e.target.value;
                        setUserData({ ...userData, email: v });
                        if (v.trim() === "")
                          setUserErrors({ ...userErrors, email: "" });
                        else if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(v))
                          setUserErrors({
                            ...userErrors,
                            email: "Enter a valid email.",
                          });
                        else setUserErrors({ ...userErrors, email: "" });
                      }}
                      className={inputCls(!!userErrors.email)}
                      disabled={!isEditable}
                    />
                  </InputField>

                  <div className="grid grid-cols-2 gap-4">
                    <InputField
                      label="Pin Code"
                      required
                      error={userErrors.pincode}
                    >
                      <input
                        type="text"
                        placeholder="6-digit pincode"
                        value={userData.pincode}
                        onChange={(e) => {
                          const v = e.target.value;
                          if (/^\d{0,6}$/.test(v)) {
                            setUserData({ ...userData, pincode: v });
                            setUserErrors({
                              ...userErrors,
                              pincode:
                                v.length !== 6 ? "Must be 6 digits." : "",
                            });
                          }
                        }}
                        className={inputCls(!!userErrors.pincode)}
                        disabled={!isEditable}
                      />
                    </InputField>

                    <InputField label="Mobile Number" required>
                      <input
                        type="text"
                        value={mobileNumber}
                        readOnly
                        className="w-full h-11 px-4 bg-[#f8fafa] border-[1.5px] border-[#e2eaea] rounded-xl text-[13px] text-[#8faba9] outline-none cursor-not-allowed"
                      />
                    </InputField>
                  </div>

                  <div className="bg-[#f8fafa] border border-[#e2eaea] rounded-xl p-4">
                    <p className="text-[11px] text-[#8faba9] mb-3 flex items-center gap-1.5">
                      <svg
                        width="12"
                        height="12"
                        viewBox="0 0 24 24"
                        fill="none"
                        stroke="currentColor"
                        strokeWidth="2.5"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      >
                        <circle cx="12" cy="12" r="10" />
                        <line x1="12" y1="8" x2="12" y2="12" />
                        <line x1="12" y1="16" x2="12.01" y2="16" />
                      </svg>
                      Optional — for business orders
                    </p>
                    <InputField label="GST Number">
                      <input
                        type="text"
                        value={userData.gst_number}
                        onChange={(e) =>
                          setUserData({
                            ...userData,
                            gst_number: e.target.value,
                          })
                        }
                        placeholder="e.g. 22AAAAA0000A1Z5"
                        className={inputCls(false)}
                        disabled={!isEditable}
                      />
                    </InputField>
                  </div>

                  {isEditable && (
                    <button
                      type="submit"
                      className="w-full h-11 bg-[#162c2a] hover:bg-[#1e4a46] text-white font-semibold text-[14px] rounded-xl transition-all duration-200 shadow-[0_2px_10px_rgba(22,44,42,0.25)] hover:shadow-[0_4px_16px_rgba(22,44,42,0.35)] hover:-translate-y-px flex items-center justify-center gap-2 mt-2"
                    >
                      <svg
                        width="14"
                        height="14"
                        viewBox="0 0 24 24"
                        fill="none"
                        stroke="currentColor"
                        strokeWidth="2.5"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      >
                        <path d="M19 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h11l5 5v11a2 2 0 0 1-2 2z" />
                        <polyline points="17 21 17 13 7 13 7 21" />
                        <polyline points="7 3 7 8 15 8" />
                      </svg>
                      Save Changes
                    </button>
                  )}
                </form>
              </div>
            </div>
          </div>
        )}

        {/* ── ADDRESSES TAB ── */}
        {activeTab === "addresses" && (
          <div className="max-w-full">
            <div className="flex items-center justify-between mb-6">
              <h2 className="font-bold text-[17px] text-[#1e4a46]">
                Saved Addresses
              </h2>
              <button
                onClick={() => setPopupOpen(true)}
                className="flex items-center gap-2 bg-[#ff601e] hover:bg-[#e55519] text-white font-semibold text-[12px] px-4 h-9 rounded-xl transition-all duration-200 shadow-[0_2px_8px_rgba(255,96,30,0.3)]"
              >
                <svg
                  width="12"
                  height="12"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  strokeWidth="2.5"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                >
                  <line x1="12" y1="5" x2="12" y2="19" />
                  <line x1="5" y1="12" x2="19" y2="12" />
                </svg>
                Add Address
              </button>
            </div>

            {errorMessage && (
              <p className="text-red-500 text-[13px] mb-4">{errorMessage}</p>
            )}

            {addresses.length === 0 ? (
              <div className="bg-white rounded-2xl border border-[#e2eaea] p-10 flex flex-col items-center gap-3 text-center">
                <div className="w-14 h-14 rounded-2xl bg-[#eaf4f3] border border-[#d4ecea] flex items-center justify-center">
                  <svg
                    width="24"
                    height="24"
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="#5fbdb3"
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  >
                    <path d="M21 10c0 7-9 13-9 13s-9-6-9-13a9 9 0 0 1 18 0z" />
                    <circle cx="12" cy="10" r="3" />
                  </svg>
                </div>
                <p className="font-semibold text-[15px] text-[#374747]">
                  No addresses saved yet
                </p>
                <p className="text-[13px] text-[#8faba9]">
                  Add a delivery address to speed up checkout
                </p>
              </div>
            ) : (
              <div className="flex flex-col gap-4">
                {addresses.map((address) => (
                  <div
                    key={address.address_id}
                    className={`bg-white rounded-2xl border transition-all duration-200 p-5 relative overflow-hidden ${
                      address.is_default === true ||
                      address.is_default === "true"
                        ? "border-[#5fbdb3] shadow-[0_4px_18px_rgba(22,44,42,0.1)]"
                        : "border-[#e2eaea] shadow-[0_2px_8px_rgba(22,44,42,0.05)]"
                    }`}
                  >
                    {/* Top accent for default */}
                    {(address.is_default === true ||
                      address.is_default === "true") && (
                      <div className="absolute top-0 left-0 right-0 h-[2.5px] bg-gradient-to-r from-[#1e4a46] to-[#5fbdb3]" />
                    )}
                    <div className="flex items-start justify-between gap-4">
                      <div className="flex items-start gap-3 flex-1 min-w-0">
                        {/* Radio + icon */}
                        <div
                          className={`flex-shrink-0 w-9 h-9 rounded-xl flex items-center justify-center mt-0.5 ${
                            address.is_default === true ||
                            address.is_default === "true"
                              ? "bg-[#1e4a46] text-white"
                              : "bg-[#f1f5f5] text-[#8faba9]"
                          }`}
                        >
                          <svg
                            width="14"
                            height="14"
                            viewBox="0 0 24 24"
                            fill="none"
                            stroke="currentColor"
                            strokeWidth="2.5"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                          >
                            <path d="M21 10c0 7-9 13-9 13s-9-6-9-13a9 9 0 0 1 18 0z" />
                            <circle cx="12" cy="10" r="3" />
                          </svg>
                        </div>
                        <div className="flex-1 min-w-0">
                          <div className="flex items-center gap-2 flex-wrap mb-1">
                            <p className="font-bold text-[14px] text-[#1e4a46]">
                              {address.address_title}
                            </p>
                            {(address.is_default === true ||
                              address.is_default === "true") && (
                              <span className="text-[9px] font-bold uppercase tracking-wide bg-[#eaf4f3] text-[#1e4a46] border border-[#d4ecea] px-2 py-0.5 rounded-full">
                                Default
                              </span>
                            )}
                          </div>
                          <p className="text-[12px] text-[#607d7b] leading-relaxed">
                            {[
                              address.address_line_1,
                              address.address_line_2,
                              address.city,
                              address.state,
                            ]
                              .filter(Boolean)
                              .join(", ")}
                            {address.pincode && ` — ${address.pincode}`}
                          </p>
                          {address.mobile_number && (
                            <p className="text-[11px] text-[#8faba9] mt-1 flex items-center gap-1">
                              <svg
                                width="10"
                                height="10"
                                viewBox="0 0 24 24"
                                fill="none"
                                stroke="currentColor"
                                strokeWidth="2.5"
                                strokeLinecap="round"
                                strokeLinejoin="round"
                              >
                                <path d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6 19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72c.127.96.361 1.903.7 2.81a2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45c.907.339 1.85.573 2.81.7A2 2 0 0 1 22 16.92z" />
                              </svg>
                              {address.mobile_number}
                            </p>
                          )}
                        </div>
                      </div>
                      {/* Actions */}
                      <div className="flex items-center gap-2 flex-shrink-0">
                        <button
                          onClick={() => handleEditClick(address)}
                          className="w-8 h-8 rounded-xl border border-[#e2eaea] bg-white flex items-center justify-center text-[#374747] hover:bg-[#eaf4f3] hover:border-[#5fbdb3] hover:text-[#1e4a46] transition-all duration-200"
                        >
                          <svg
                            width="13"
                            height="13"
                            viewBox="0 0 24 24"
                            fill="none"
                            stroke="currentColor"
                            strokeWidth="2.5"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                          >
                            <path d="M11 4H4a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-7" />
                            <path d="M18.5 2.5a2.121 2.121 0 0 1 3 3L12 15l-4 1 1-4 9.5-9.5z" />
                          </svg>
                        </button>
                        <button
                          onClick={() =>
                            handleDeleteAddress(address.address_id)
                          }
                          className="w-8 h-8 rounded-xl border border-[#e2eaea] bg-white flex items-center justify-center text-[#374747] hover:bg-[#feecec] hover:border-red-200 hover:text-red-500 transition-all duration-200"
                        >
                          <svg
                            width="13"
                            height="13"
                            viewBox="0 0 24 24"
                            fill="none"
                            stroke="currentColor"
                            strokeWidth="2.5"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                          >
                            <polyline points="3 6 5 6 21 6" />
                            <path d="M19 6l-1 14a2 2 0 0 1-2 2H8a2 2 0 0 1-2-2L5 6" />
                            <path d="M10 11v6" />
                            <path d="M14 11v6" />
                            <path d="M9 6V4a1 1 0 0 1 1-1h4a1 1 0 0 1 1 1v2" />
                          </svg>
                        </button>
                      </div>
                    </div>
                  </div>
                ))}
              </div>
            )}
          </div>
        )}
      </div>

      {/* ── Edit Address Modal ── */}
      {isEditPopupOpen && selectedAddress && (
        <div className="fixed inset-0 z-50 flex items-center justify-center bg-[#0a1715]/60 backdrop-blur-sm px-4">
          <div className="bg-white rounded-2xl shadow-[0_20px_60px_rgba(0,0,0,0.3)] w-full max-w-[560px] max-h-[90vh] overflow-hidden flex flex-col">
            {/* Modal header */}
            <div className="relative bg-[#162c2a] px-6 py-5 flex-shrink-0">
              <div
                className="absolute inset-0 opacity-[0.05] pointer-events-none"
                style={{
                  backgroundImage: plusPattern,
                  backgroundRepeat: "repeat",
                  backgroundSize: "40px 40px",
                }}
              />
              <div className="relative flex items-center justify-between">
                <h2 className="font-bold text-[16px] text-white">
                  Edit Address
                </h2>
                <button
                  onClick={handleClosePopup}
                  className="w-8 h-8 rounded-xl bg-white/[0.1] hover:bg-white/[0.2] flex items-center justify-center transition-colors"
                >
                  <svg
                    width="14"
                    height="14"
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="white"
                    strokeWidth="2.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  >
                    <line x1="18" y1="6" x2="6" y2="18" />
                    <line x1="6" y1="6" x2="18" y2="18" />
                  </svg>
                </button>
              </div>
            </div>

            {/* Modal body */}
            <div className="overflow-y-auto p-6 flex flex-col gap-4">
              <InputField
                label="Address Name"
                required
                error={
                  titleValue.length > 0 && !isNameValid
                    ? "Only letters allowed."
                    : ""
                }
              >
                <input
                  type="text"
                  name="address_title"
                  placeholder="Home, Office…"
                  value={selectedAddress.address_title || ""}
                  onChange={handleChange}
                  maxLength={25}
                  className={inputCls(titleValue.length > 0 && !isNameValid)}
                />
              </InputField>
              <InputField
                label="Address Line 1"
                required
                error={errors.address_line_1}
              >
                <input
                  type="text"
                  name="address_line_1"
                  placeholder="Street, Building"
                  value={selectedAddress.address_line_1 || ""}
                  onChange={handleChange}
                  maxLength={120}
                  className={inputCls(!!errors.address_line_1)}
                />
              </InputField>
              <InputField label="Address Line 2" error={errors.address_line_2}>
                <input
                  type="text"
                  name="address_line_2"
                  placeholder="Area, Landmark (optional)"
                  value={selectedAddress.address_line_2 || ""}
                  onChange={handleChange}
                  maxLength={25}
                  className={inputCls(!!errors.address_line_2)}
                />
              </InputField>
              <div className="grid grid-cols-2 gap-4">
                <InputField
                  label="City"
                  required
                  error={
                    cityValue.length > 0 && !isCityValid
                      ? "Only letters allowed."
                      : ""
                  }
                >
                  <input
                    type="text"
                    name="city"
                    placeholder="City"
                    value={selectedAddress.city || ""}
                    onChange={handleChange}
                    maxLength={20}
                    className={inputCls(cityValue.length > 0 && !isCityValid)}
                  />
                </InputField>
                <InputField
                  label="Pincode"
                  required
                  error={
                    errors.pincode ||
                    ((selectedAddress.pincode || "").length > 0 &&
                    !isPincodeValid
                      ? "6 digits only."
                      : "")
                  }
                >
                  <input
                    type="text"
                    name="pincode"
                    placeholder="6-digit"
                    value={selectedAddress.pincode || ""}
                    onChange={(e) => {
                      if (/^\d{0,6}$/.test(e.target.value)) handleChange(e);
                    }}
                    className={inputCls(
                      !!errors.pincode ||
                        ((selectedAddress.pincode || "").length > 0 &&
                          !isPincodeValid),
                    )}
                  />
                </InputField>
              </div>
              <InputField label="State" required>
                <select
                  name="state"
                  value={selectedAddress.state || ""}
                  onChange={handleChange}
                  className={`${inputCls(false)} cursor-pointer`}
                >
                  <option value="">Select State</option>
                  {indianStates.map((st) => (
                    <option key={st} value={st}>
                      {st}
                    </option>
                  ))}
                </select>
              </InputField>
              <InputField
                label="Mobile Number"
                required
                error={
                  errors.mobile_number ||
                  ((selectedAddress.mobile_number || "").length > 0 &&
                  !isMobileValid
                    ? "10 digits only."
                    : "")
                }
              >
                <div className="flex">
                  <div className="flex items-center gap-1.5 px-3 bg-[#f8fafa] border-[1.5px] border-r-0 border-[#e2eaea] rounded-l-xl h-11 flex-shrink-0">
                    <span className="text-[14px]">🇮🇳</span>
                    <span className="text-[13px] font-semibold text-[#374747]">
                      +91
                    </span>
                  </div>
                  <input
                    type="tel"
                    name="mobile_number"
                    placeholder="10-digit number"
                    value={selectedAddress.mobile_number || ""}
                    onChange={(e) => {
                      if (/^\d{0,10}$/.test(e.target.value)) handleChange(e);
                    }}
                    maxLength={10}
                    className={`flex-1 h-11 px-3 bg-white border-[1.5px] rounded-r-xl outline-none text-[13px] text-[#1a2625] ${errors.mobile_number || ((selectedAddress.mobile_number || "").length > 0 && !isMobileValid) ? "border-red-400" : "border-[#e2eaea] focus:border-[#1e4a46]"}`}
                  />
                </div>
              </InputField>
              <div>
                <p className="text-[12px] font-semibold text-[#374747] mb-2">
                  Set as default address?
                </p>
                <div className="flex gap-4">
                  {[
                    { val: true, label: "Yes" },
                    { val: false, label: "No" },
                  ].map((opt) => (
                    <label
                      key={String(opt.val)}
                      className="flex items-center gap-2 cursor-pointer"
                    >
                      <input
                        type="radio"
                        name="is_default"
                        checked={selectedAddress.is_default === opt.val}
                        onChange={() =>
                          handleChange({
                            target: { name: "is_default", value: opt.val },
                          })
                        }
                        className="accent-[#1e4a46]"
                      />
                      <span className="text-[13px] text-[#374747] font-medium">
                        {opt.label}
                      </span>
                    </label>
                  ))}
                </div>
              </div>
            </div>

            {/* Modal footer */}
            <div className="flex items-center justify-end gap-3 px-6 py-4 border-t border-[#f1f5f5] flex-shrink-0 bg-[#f8fafa]">
              <button
                onClick={handleClosePopup}
                className="h-10 px-5 rounded-xl border border-[#e2eaea] text-[#374747] text-[13px] font-semibold hover:bg-[#e2eaea] transition-all duration-200"
              >
                Cancel
              </button>
              <button
                onClick={handleSave}
                disabled={!isEditFormValid}
                className="h-10 px-5 rounded-xl bg-[#1e4a46] hover:bg-[#162c2a] text-white text-[13px] font-semibold transition-all duration-200 disabled:opacity-40 disabled:cursor-not-allowed shadow-[0_2px_8px_rgba(22,44,42,0.25)]"
              >
                Save Address
              </button>
            </div>
          </div>
        </div>
      )}

      {isPopupOpen && (
        <Adresspopup
          onClose={() => setPopupOpen(false)}
          fetchAddresses={fetchAddresses}
        />
      )}
    </div>
  );
};

export default ProfilePage;
